import type { IntlShape } from 'react-intl';
import { CertificateStatusEnum } from '@share/common-types';
import styles from './styles.module.scss';

export function getCertificateStatusBadgeModifier(status: CertificateStatusEnum): string {
  switch (status) {
    case CertificateStatusEnum.Canceled:
      return 'canceled';
    case CertificateStatusEnum.Active:
      return 'active';
    case CertificateStatusEnum.PartiallyRedeemed:
      return 'partiallyRedeemed';
    case CertificateStatusEnum.Expired:
      return 'expired';
    case CertificateStatusEnum.Redeemed:
      return 'redeemed';
    case CertificateStatusEnum.Pending:
      return 'pending';
    default:
      return 'neutral';
  }
}

const STATUS_TO_MESSAGE_ID: Record<CertificateStatusEnum, string> = {
  [CertificateStatusEnum.New]: 'certificates.detail.certificate.status.new',
  [CertificateStatusEnum.Pending]: 'certificates.detail.certificate.status.pending',
  [CertificateStatusEnum.Active]: 'certificates.detail.certificate.status.active',
  [CertificateStatusEnum.PartiallyRedeemed]:
    'certificates.detail.certificate.status.partiallyRedeemed',
  [CertificateStatusEnum.Redeemed]: 'certificates.detail.certificate.status.redeemed',
  [CertificateStatusEnum.Expired]: 'certificates.detail.certificate.status.expired',
  [CertificateStatusEnum.Canceled]: 'certificates.detail.certificate.status.canceled',
};

export function getCertificateStatusMessageId(status: CertificateStatusEnum): string {
  return STATUS_TO_MESSAGE_ID[status] ?? 'certificates.detail.certificate.status.pending';
}

export function formatDetailDate(iso: string, intl: IntlShape): string {
  if (!iso) {
    return '';
  }
  const parsed: Date = new Date(iso);
  if (Number.isNaN(parsed.getTime())) {
    return '';
  }
  return intl.formatDate(parsed, { year: 'numeric', month: 'numeric', day: 'numeric' });
}

export function resolveBadgeToneClass(modifier: string): string {
  switch (modifier) {
    case 'active':
      return styles.active;
    case 'partiallyRedeemed':
      return styles.partiallyRedeemed;
    case 'expired':
      return styles.expired;
    case 'redeemed':
      return styles.redeemed;
    case 'canceled':
      return styles.canceled;
    case 'pending':
      return styles.pending;
    default:
      return styles.neutral;
  }
}
